import React from 'react';
import ReactDOM from 'react-dom';
import App from './App.js';
import reportWebVitals from './reportWebVitals';


import rtlPlugin from 'stylis-plugin-rtl';
import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';
import { prefixer } from 'stylis';
import { createTheme, ThemeProvider } from '@mui/material';
import { BrowserRouter } from "react-router-dom";
import * as ReactDOMClient from 'react-dom/client';


const theme = createTheme({
  direction: 'rtl',
  typography: {
    fontFamily: 'Almarai, Tahoma'
  },
  palette: {
    primary: {
      main: '#ed4230',
    }
  }
});

// Create rtl cache
const cacheRtl = createCache({
  key: 'muirtl',
  stylisPlugins: [prefixer, rtlPlugin],
});



const root = ReactDOMClient.createRoot(

  document.getElementById('root')
);

root.render(<React.StrictMode>
  <BrowserRouter>
    <CacheProvider value={cacheRtl}>
      <ThemeProvider theme={theme}>
        <App />
      </ThemeProvider>
    </CacheProvider>
  </BrowserRouter>
</React.StrictMode>);
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
